// DashboardGraphs.js
import React from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Card, CardBody, CardTitle, Row, Col } from 'reactstrap';

const DashboardGraphs = ({ bookingCount, buddiesCount , listingCount , userCount }) => {
  // Sample data for demonstration; replace with actual data as needed
  const graphData = {
    labels: ['Total Bookings', 'Canceled Bookings', 'Completed Bookings', 'Conversion Rate'],
    datasets: [
      {
        label: 'Count',
        data: [userCount, buddiesCount,listingCount, bookingCount], 
        backgroundColor: [
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
          'rgba(255, 99, 132, 0.6)',
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const doughnutData = {
    labels: ['Total Buddies ', 'Total Users'],
    datasets: [
      {
        data: [userCount , buddiesCount], 
        backgroundColor: [
          'rgba(255, 205, 86, 0.6)',
          'rgba(153, 102, 255, 0.6)',
        ],
        borderColor: [
          'rgba(255, 205, 86, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <Row className="mt-4">
        <Col lg="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Booking Statistics</CardTitle>
              <Bar
                data={graphData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      position: 'top',
                    },
                    title: {
                      display: true,
                      text: 'Users Overview',
                    },
                  },
                }}
              />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Total users</CardTitle>
              <Doughnut
                data={doughnutData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      position: 'top',
                    },
                    title: {
                      display: true,
                      text: 'Total Users vs Total Buddies',
                    },
                  },
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DashboardGraphs;
